<template>
  <div class="content if-profile report-tab">
    <div class="md-layout if-profile-body">
      <IFReportHeader :headerData="this.headerData" />

      <!-- <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <div class="navbar md-toolbar md-transparent md-elevation-4">
          <div class="md-toolbar-section-start">
            <div>
              <h1 class="md-title profile-title">Valuation Multiples</h1>
            </div>
          </div>
        </div>
      </div>-->

      <div class="md-layout-item p-0">
        <md-card>
          <!-- <md-card-header class="md-card-header-icon">
            <div class="card-icon">
              <md-icon>query_stats</md-icon>
            </div>
            <h4 class="title text-left">
              [238220 Plumbing, Heating, and Air Conditioning Contractors <br />
              <small
                >Valuations are derived from closed business sales as well as
                enterprise-level revenue and industry financial analysis
                developed by Bizminer.
              </small>
            </h4>
          </md-card-header>-->
          <div class="md-layout md-card if_card">
            <div class="md-layout-item md-medium-size-100 md-size-100 p-0">
              <md-card-header class="md-card-header md-card-header-icon">
                <div class="card_icon">
                  <md-icon>light_mode</md-icon>
                </div>About Valuation Multiples
              </md-card-header>
              <div class="md-card-content">
                <div class="extra_space">
                  <p>
                    <b>Business Value Insight Terms</b>: The Bizminer Valuations Value basis is derived from projected company sales; peer group average earnings %; and industry valuation multiples. Median
                    ranges reflect a range of market conditions and business performance at this revenue scale.<br/><br/>
                    You should not use Bizminer Valuations in place of a professional valuation or as the basis of any specific business-related or other financial transaction; nor to secure a
                    business or personal loan.<br/><br/>
                    <b>Owner Earnings (Cash Flow) Approach:</b> Revenue/Owner Earnings market valuation approach<br/><br/>
                    <b>Sales Approach:</b> Revenue/Annual Sales market value approach<br/><br/>
                    <b>Note:</b> Median is the point at which 50% of a sample is above and 50% of the same below the value. Quartile 1 lies at the mid-point between the median and the lowest value; Quartile 3
                    between the median and the highest value.
                  </p>
                  <p>
                    <b>Multiples Definitions:</b>
                    <br>
                    Our multiples are derived from the Dealstats database of more than 30,000 historical business sale transactions. Bizminer cleans and filters the database for locations and anomalies, and applies standard outlier protocols and exclusion calculations to the raw data to determine median and quartile values at the NAICS-4-5-6 levels.
                    <br>
                    The Earning Multiple calculation is:<br>
                    Sale Price / Discretionary Owner Earnings<br>
                    where:<br>
                    Discretionary Owner Earnings = Operating Profit + Owner’s Compensation + Depreciation/Amortization)
                    <br><br>
                    Sale Price is the total consideration paid to the seller and includes any cash, notes, and/or securities that were used as a form of payment plus any interest-bearing liabilities the buyer assumed. The Sale Price includes the non-compete value and the assumption of interest-bearing liabilities and excludes: (1) the real estate value; (2) any earn-outs (because they have not yet been earned and they may not be earned); and (3) the employment/consulting agreement values.
                    <br><br>
                    Asset Sale Note: In an Asset Sale, the assumption is that all or substantially all operating assets are transferred in the sale. In an Asset Sale, the Sale Price may or may not include all current assets, non-current assets, and current liabilities (liabilities are typically not transferred in an asset sale).
                    <br><br>
                    Selling Price: The selling price is the total consideration paid to the seller and includes any cash, notes, and/or securities that were used as a form of payment plus any interest-bearing liabilities the buyer assumed. The selling price includes the non-compete value and the assumption of interest-bearing liabilities and excludes the real estate value; any earn-outs; and the employment/consulting agreement values. In an Asset Sale, the assumption is that all or substantially all operating assets are transferred in the sale.
                    <br><br>
                    <b>Bizminer Valuation Multiples Limitations</b><br>
                    You should not use Bizminer Valuation Multiples or the Toolkit in place of a valuation. Bizminer does not suggest using Valuation Multiples or the Toolkit as the basis of any specific business-related or other financial transaction. You should not attempt to use a Valuation Multiples or other Toolkit elements to secure a business or personal loan. Our data sources may be incomplete or incorrect; nor have we physically researched or inspected many important details necessary to the valuation of a specific enterprise. Neither the Valuation Multiples nor other Toolkit tools consider the market environment details nor the idiosyncrasies of a firm’s performance that can influence the actual value or selling price.
                    <br><br>
                    Multiple values are presented at the most detailed available industry level. In some cases, detailed NAICS or sales group transaction records do not include the minimum number of transactions required for our multiples calculations. In those cases, we may display multiples which reflect values of the directly related NAICS parent industry or sales group. Depending on availability, multiples for one approach (sales or earnings) may reflect a more detailed industry tier than the other.
                    <br><br>
                    We encourage business buyers, sellers, owners and browsers to enhance their understanding of the value of any enterprise before making decisions or taking action. The Valuation Multiples and other Toolkit elements are modeled informational tools, not guides to action. For that we recommend obtaining an appraisal from a business broker, a valuation from a certified valuation professional, or both.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <md-card-content class="p-0 negetive_margin">
            <div class="md-layout">
              <div class="md-layout-item md-medium-size-100 tbl-box md-size-50">
                <!-- <h5 class="title text-left">Firms Analyzed</h5> -->
                <div class="md-card if_card">
                  <table-card class="md_table m-0">
                    <template slot="header" header-color="rose">
                      <!-- <div class="card-icon">
                        <i class="md-icon md-icon-font md-theme-default"
                          >receipt</i
                        >
                      </div>-->
                      <h4 class="title m-0">
                        <div
                          class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                        >Sales Group: &#60; $2.5m</div>
                      </h4>
                    </template>

                    <template slot="content">
                      <div class="md-layout">
                        <div class="md-layout-item md-size-100 p-0">
                          <md-table v-model="tableInfo" table-header-color="blue">
                            <md-table-row slot="md-table-row" slot-scope="{ item }">
                              <md-table-cell md-label>
                                <div class="md-table-side-label">{{ item.name }}</div>
                              </md-table-cell>
                              <md-table-cell md-label="Sales Multiples">
                                {{
                                  multiplesA[`Sales${item.id}`]
                                }}
                              </md-table-cell>
                              <md-table-cell md-label="Earnings Multiples">
                                {{
                                  multiplesA[`Earnings${item.id}`]
                                }}
                              </md-table-cell>
                            </md-table-row>
                          </md-table>
                        </div>
                      </div>
                    </template>
                  </table-card>
                </div>
              </div>
              <div class="md-layout-item md-medium-size-100 tbl-box md-size-50">
                <!-- <h5 class="title text-left">Firms Analyzed</h5> -->
                <div class="md-card if_card">
                  <table-card class="md_table m-0">
                    <template slot="header" header-color="rose">
                      <!-- <div class="card-icon">
                      <i class="md-icon md-icon-font md-theme-default"
                        >receipt</i
                      >
                      </div>-->
                      <h4 class="title m-0">
                        <div
                          class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                        >Sales Group: $2.5m - $24.9m</div>
                      </h4>
                    </template>

                    <template slot="content">
                      <div class="md-layout">
                        <div class="md-layout-item md-size-100 p-0">
                          <md-table v-model="tableInfo" table-header-color="blue">
                            <md-table-row slot="md-table-row" slot-scope="{ item }">
                              <md-table-cell md-label>
                                <div class="md-table-side-label">{{ item.name }}</div>
                              </md-table-cell>
                              <md-table-cell md-label="Sales Multiples">
                                {{
                                  multiplesB[`Sales${item.id}`]
                                }}
                              </md-table-cell>
                              <md-table-cell md-label="Earnings Multiples">
                                {{
                                  multiplesB[`Earnings${item.id}`]
                                }}
                              </md-table-cell>
                            </md-table-row>
                          </md-table>
                        </div>
                      </div>
                    </template>
                  </table-card>
                </div>
              </div>
              <div class="md-layout-item md-medium-size-100 tbl-box md-size-50">
                <!-- <h5 class="title text-left">Firms Analyzed</h5> -->
                <div class="md-card if_card">
                  <table-card class="md_table m-0">
                    <template slot="header" header-color="rose">
                      <!-- <div class="card-icon">
                      <i class="md-icon md-icon-font md-theme-default"
                        >receipt</i
                      >
                      </div>-->
                      <h4 class="title m-0">
                        <div
                          class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                        >Sales Group: &#62; $25m</div>
                      </h4>
                    </template>

                    <template slot="content">
                      <div class="md-layout">
                        <div class="md-layout-item md-size-100 p-0">
                          <md-table v-model="tableInfo" table-header-color="blue">
                            <md-table-row slot="md-table-row" slot-scope="{ item }">
                              <md-table-cell md-label>
                                <div class="md-table-side-label">{{ item.name }}</div>
                              </md-table-cell>
                              <md-table-cell md-label="Sales Multiples">
                                {{
                                  multiplesC[`Sales${item.id}`]
                                }}
                              </md-table-cell>
                              <md-table-cell md-label="Earnings Multiples">
                                {{
                                  multiplesC[`Earnings${item.id}`]
                                }}
                              </md-table-cell>
                            </md-table-row>
                          </md-table>
                        </div>
                      </div>
                    </template>
                  </table-card>
                </div>
              </div>
              <div class="md-layout-item md-medium-size-100 tbl-box md-size-50">
                <!-- <h5 class="title text-left">Firms Analyzed</h5> -->
                <div class="md-card if_card">
                  <table-card class="md_table m-0">
                    <template slot="header" header-color="rose">
                      <!-- <div class="card-icon">
                      <i class="md-icon md-icon-font md-theme-default"
                        >receipt</i
                      >
                      </div>-->
                      <h4 class="title m-0">
                        <div
                          class="md-layout-item md-medium-size-100 md-size-100 card-title p-0"
                        >Sales Group: All</div>
                      </h4>
                    </template>

                    <template slot="content">
                      <div class="md-layout">
                        <div class="md-layout-item md-size-100 p-0">
                          <md-table v-model="tableInfo" table-header-color="blue">
                            <md-table-row slot="md-table-row" slot-scope="{ item }">
                              <md-table-cell md-label>
                                <div class="md-table-side-label">{{ item.name }}</div>
                              </md-table-cell>
                              <md-table-cell md-label="Sales Multiples">
                                {{
                                  multiplesAll[`Sales${item.id}`]
                                }}
                              </md-table-cell>
                              <md-table-cell md-label="Earnings Multiples">
                                {{
                                  multiplesAll[`Earnings${item.id}`]
                                }}
                              </md-table-cell>
                            </md-table-row>
                          </md-table>
                        </div>
                      </div>
                    </template>
                  </table-card>
                </div>
              </div>
            </div>
          </md-card-content>
        </md-card>
      </div>


    </div>
  </div>
</template>

<script>
import { TableCard } from '@/components';
import { mapState } from 'vuex';
import IFReportHeader from './_partials/IFHeader.vue';

export default {
  components: {
    IFReportHeader,
    TableCard,
  },
  props: ['headerData'],
  data() {
    return {
      tableInfo: [
        {
          id: 'Low',
          name: 'Q1',
        },
        {
          id: 'Med',
          name: 'Median',
        },
        {
          id: 'High',
          name: 'Q3',
        },
      ],
    };
  },
  computed: {
    ...mapState({
      multiplesA: (state) => {
        return state.user.report['multiples_A']
          ? state.user.report['multiples_A']
          : [];
      },
      multiplesB: (state) => {
        return state.user.report['multiples_B']
          ? state.user.report['multiples_B']
          : [];
      },
      multiplesC: (state) => {
        return state.user.report['multiples_C']
          ? state.user.report['multiples_C']
          : [];
      },
      multiplesAll: (state) => {
        return state.user.report['multiples_all']
          ? state.user.report['multiples_all']
          : [];
      },
    }),
  },
  methods: {},
};
</script>
<style lang="scss">
.introduction-body {
  display: flex;
  align-items: flex-start;
}
.introduction-title {
  display: flex;
  flex-direction: column;
  justify-content: end;
}
</style>
